import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { AspectRatio, ResourceVm } from 'qp-ui-interface';
import { NavigationLibraryService } from '../../services/navigation/navigation.service';

type CardSize = 'normal' | 'small';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
})
export class CardComponent {
  @Input() index: number;
  @Input() showTitle = false;
  @Input() img = '';
  @Input() title = '';
  @Input() item = {} as any;
  @Input() ratio = '' as AspectRatio;
  @Input() size: CardSize = 'normal';
  @ViewChild('cardlist') cardlist: ElementRef;
  @ViewChild('imagcontainer') imgContainer: ElementRef;
  @Output() onCardFocus = new EventEmitter();

  constructor(private navService: NavigationLibraryService) {}

  addScroll(): void {
    this.onCardFocus.emit();
    if (
      this.cardlist?.nativeElement.getElementsByTagName('h5')[0]?.scrollWidth >
      this.cardlist?.nativeElement.getElementsByTagName('h5')[0]?.clientWidth
    ) {
      this.cardlist.nativeElement.classList.add('autoScroll');
    }
  }

  getImageWidth(item: ResourceVm): string {
    return item.image.split('width=')[1].split('&')[0];
  }

  removeScroll(): void {
    this.cardlist.nativeElement.classList.remove('autoScroll');
  }

  focusCard(): void {
    this.navService.focusElement(this.imgContainer.nativeElement, this.index, 0);
  }
}
